// @flow

// TruSTAR Themes
import * as DefaultThemeConfiguration from './default/index';
import * as DarkThemeConfiguration from './dark/index';

// Splunk Themes
import * as SplunkDefaultThemeConfiguration from './splunk-default/index';
import * as SplunkDarkThemeConfiguration from './splunk-dark';
import * as LegacyDefaultThemeConfiguration from './default/index';
import * as LegacyDarkThemeConfiguration from './dark/index';

// Shared Globals
import * as CommonConfiguration from './common/index';

export const DefaultTheme = {
  ...SplunkDefaultThemeConfiguration,
  ...CommonConfiguration,
};

export const DarkTheme = {
  ...SplunkDarkThemeConfiguration,
  ...CommonConfiguration,
};

export const LegacyDefaultTheme = {
  ...LegacyDefaultThemeConfiguration,
  ...CommonConfiguration,
};
export const LegacyDarkTheme = {
  ...LegacyDarkThemeConfiguration,
  ...CommonConfiguration,
};


// WEBPACK FOOTER //
// ./web_modules/trustar-2.0/themes/index.js